export interface ParsedArn {
  service: string;
  region: string;
  resourceName: string;
  consoleUrl: string;
}

export function parseArn(arn: string): ParsedArn | null {
  if (!arn) return null;
  // arn:aws:service:region:account:resource-type/resource-name or :resource-name
  const parts = arn.split(':');
  if (parts.length < 6) return null;

  const service = parts[2];
  const region = parts[3];
  const resourcePart = parts.slice(5).join(':');
  let resourceName: string;
  if (resourcePart.includes('/')) {
    resourceName = resourcePart.split('/').pop()!;
  } else if (resourcePart.includes(':')) {
    resourceName = resourcePart.split(':').pop()!;
  } else {
    resourceName = resourcePart;
  }

  let consoleUrl = '';
  switch (service) {
    case 'sns':
      consoleUrl = `https://${region}.console.aws.amazon.com/sns/v3/home?region=${region}#/topic/${arn}`;
      break;
    case 'sqs':
      consoleUrl = `https://${region}.console.aws.amazon.com/sqs/v3/home?region=${region}#/queues/${encodeURIComponent(`https://sqs.${region}.amazonaws.com/${parts[4]}/${resourceName}`)}`;
      break;
    case 'lambda':
      consoleUrl = `https://${region}.console.aws.amazon.com/lambda/home?region=${region}#/functions/${resourceName}`;
      break;
    case 'events':
      consoleUrl = `https://${region}.console.aws.amazon.com/events/home?region=${region}#/eventbus/${resourceName}`;
      break;
    default:
      consoleUrl = `https://${region}.console.aws.amazon.com/${service}/home?region=${region}`;
  }

  return { service, region, resourceName, consoleUrl };
}

export function getServiceLabel(service: string): string {
  switch (service) {
    case 'sns': return 'SNS';
    case 'sqs': return 'SQS';
    case 'lambda': return 'Lambda';
    case 'events': return 'EventBridge';
    default: return service.toUpperCase();
  }
}
